import { createContext } from 'react';

const resourceStepContext = createContext({
  currentStep: '',
});

export default resourceStepContext;
